import {
    androidAddButtonElement,
    NotificationAndroidActionType,
    PlatformType,
} from './constants';

import {
    NotificationButtonElement,
    NotificationButtonFormValues,
} from '../../../../../../models/formula.model';
import { IosCategoryIdentifier } from '../../../../../../models/notificationButton.model';

import { toastService } from '../../../../../../services/toast.service';

export const maxLength = (buttonsCount: number) => {
    let maxLength;
    if (buttonsCount === 1) {
        maxLength = 46;
    } else if (buttonsCount === 2) {
        maxLength = 20;
    } else {
        maxLength = 11;
    }
    return maxLength;
};

export const checkButtonTextLength = (value: string, buttonCount: number) => {
    const length = maxLength(buttonCount);
    if (value.length > length) {
        return `Warning: Button max ${length} characters. After that the text is truncated.`;
    }
    return '';
};

export const isIosButtonValidFilled = (
    iosButtons: NotificationButtonElement[],
) => {
    const lastButton = iosButtons?.[0];
    if (!lastButton) {
        return false;
    }
    const regex =
        /^(https?:\/\/)?([^\s:@]+(:[^\s:@]*)?@)?([^\s:@]+\.[^\s:@]+)(:\d+)?(\/[^\s]*)?$/i;
    if (lastButton.action !== NotificationAndroidActionType.OPEN_APP) {
        return lastButton.uri && regex.test(lastButton.uri);
    }
    return true;
};

export const filterButtonsByPlatform = (
    data: NotificationButtonElement[] | undefined,
    platform: PlatformType,
): NotificationButtonElement[] => {
    return data?.filter((item) => item.platform === platform) || [];
};

export const getInitialValues = (
    data: NotificationButtonElement[] | undefined,
    iosCategoryIdentifier: IosCategoryIdentifier,
): NotificationButtonFormValues => {
    const androidPlatformButtons = filterButtonsByPlatform(
        data,
        PlatformType.ANDROID,
    );
    const iosPlatformButtons = filterButtonsByPlatform(data, PlatformType.IOS);

    return {
        androidButtons: androidPlatformButtons.length
            ? androidPlatformButtons
            : [{ ...androidAddButtonElement }],
        iosButtons: iosPlatformButtons.length ? iosPlatformButtons : [],
        androidToggle: data?.length
            ? androidPlatformButtons.length
                ? true
                : false
            : true,
        iosToggle: data?.length
            ? iosPlatformButtons.length
                ? true
                : false
            : true,
        iosNotificationCategory: iosCategoryIdentifier ?? '',
    };
};

export const getButtonPayload = (
    values: NotificationButtonFormValues,
): NotificationButtonElement[] => {
    const androidButtons = values.androidButtons || [];
    const iosButtons = values.iosButtons || [];
    return [...androidButtons, ...iosButtons].filter((item) => item.text);
};

const getPlatformTypeForMessage = (
    sanitizedData: NotificationButtonFormValues,
): string => {
    if (sanitizedData.iosToggle && sanitizedData.androidToggle) {
        return 'both iOS and Android';
    }
    if (sanitizedData.iosToggle) {
        return PlatformType.IOS;
    }
    return PlatformType.ANDROID;
};

export const showButtonSuccessMessage = (
    buttonCount: number,
    sanitizedData: NotificationButtonFormValues,
) => {
    const platformType = getPlatformTypeForMessage(sanitizedData);
    const successMessage = buttonCount
        ? `Push action buttons have been configured for ${platformType}.`
        : 'No push action buttons have been configured.';

    toastService.showSuccess(successMessage);
};
